import { gql } from '@apollo/client'

export const CR_COUNT_TYPE_FRAGMENT = gql`
  fragment CRCountType on CRCountType {
    id
    countType
    category {
      id
      category
    }
  }
`
